import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 179 179"
      width={props.width ? props.width : '20px'}
    //   style={props.svgStyle ? props.svgStyle : {}}
      className={props.svgClass ? props.svgClass : ""}
    >
      <g 
        transform="matrix(.91473 0 0 .87295 14.548 -.281)">
        <path fill='none' d="M-15.904 0.322H179.782V205.374H-15.904z"></path>
        <clipPath id="clip_timesensitive">
          <path d="M-15.904 0.322H179.782V205.374H-15.904z"></path>
        </clipPath>
        <g clipPath="url(#clip_timesensitive)">
          <path
            d="M63.359 29.527a12.272 12.272 0 01-.042-1.019V14.905H52.152a7.295 7.295 0 01-7.292-7.291A7.295 7.295 0 0152.152.322h47.331a7.295 7.295 0 017.291 7.292 7.294 7.294 0 01-7.291 7.291H88.317v13.603c0 .344-.014.685-.041 1.023 2.55.422 5.057.971 7.513 1.64l.001.001a3.417 3.417 0 012.352 4.352l-2.553 7.872a2.877 2.877 0 01-3.499 1.885 61.306 61.306 0 00-14.725-2.17c-33.785-.854-61.908 25.881-62.762 59.666-.854 33.785 25.882 61.908 59.667 62.762 33.785.854 61.907-25.881 62.761-59.666v-.002a2.046 2.046 0 012.024-1.994l10.118-.11a2.411 2.411 0 012.438 2.472l-.001.002c-1.058 41.831-35.878 74.934-77.709 73.877C32.07 179.06-1.033 144.24.025 102.409.958 65.48 28.204 35.354 63.359 29.527zm5.167 27.603v47.195a7.291 7.291 0 003.944 6.478l24.883 12.859a7.295 7.295 0 009.825-3.13 7.296 7.296 0 00-3.13-9.826L83.109 99.885V57.13a7.296 7.296 0 00-7.292-7.292 7.295 7.295 0 00-7.291 7.292zm73.36 12.16a1.028 1.028 0 011.399.437l-.001.002a75.4 75.4 0 014.306 10.122v.001a2.447 2.447 0 01-1.602 3.13l-9.35 2.846a2.504 2.504 0 01-3.057-1.472c-.799-2.045-1.981-5.024-2.656-6.522l-.283-.624a1.825 1.825 0 01.833-2.383l10.411-5.537zm-24.373-25.621a2.177 2.177 0 013.079-.52v.001a76.282 76.282 0 017.76 6.53l.001.001a2.233 2.233 0 01.002 3.215l-7.472 7.21a1.963 1.963 0 01-2.72.004l-.001-.001a61.666 61.666 0 00-5.945-5.017l-.016-.012a2.176 2.176 0 01-.497-2.983l5.809-8.428z"
            transform="matrix(1.09322 0 0 1.14031 -.934 -.045)"
            className={props.colorClass}
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
